// Services
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import * as i0 from "@angular/core";
import * as i1 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
export class GenerateReportFolderableCollectionService extends FolderableCollectionServiceBase {
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        return this.customPDFReportService.getGenerateReports(this.dataParams);
    }
    constructor(customPDFReportService) {
        super();
        this.customPDFReportService = customPDFReportService;
    }
}
GenerateReportFolderableCollectionService.ɵfac = function GenerateReportFolderableCollectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GenerateReportFolderableCollectionService)(i0.ɵɵinject(i1.CustomPDFReportService)); };
GenerateReportFolderableCollectionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GenerateReportFolderableCollectionService, factory: GenerateReportFolderableCollectionService.ɵfac });
